import React, { useEffect, useState } from "react";
import MasterLayout from "../layouts/MasterLayout";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import AppNotification from "../helpers/AppNotification";
import PaymentModel from "../models/PaymentModel";
import ModalDeposit from "../components/paymentdeposit/ModalDeposit";
import Paginate from "../components/paginate/Paginate";
import { useDispatch } from "react-redux";
import { setShowPreloader } from "../redux/action";
import DemoModalDeposit from "../components/paymentdeposit/DemoModalDeposit";
import ModalACB from "../components/paymentdeposit/ModalACB";
import CodeMoneyModel from "../models/CodeMoneyModel";
import HomeModel from "../models/HomeModel";
import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { 
  RiWallet3Line, 
  RiFileCopyLine, 
  RiHistoryLine, 
  RiSearch2Line, 
  RiCoupon3Line,
  RiShieldFlashLine,
  RiVipCrown2Fill,
  RiDownload2Line
} from "react-icons/ri";
import "./bank-modern.css";

function PaymentDepositPage() {
  const [code, setCode] = useState("");
  const [isSubmittingCode, setIsSubmittingCode] = useState(false);
  const [selectedBank] = useState("VIB");
  const [bankInfo, setBankInfo] = useState({
    bankName: "VIB - Ngân hàng Quốc tế Việt Nam",
    accountNumber: "086714172",
    accountName: "NGUYEN THI HOA",
    qrCode: "",
    description: "VIB",
  });
  const [userData, setUserData] = useState({});

  const fetchUserData = () => {
    HomeModel.getInfoHeader()
      .then((res) => {
        setUserData(res.data || {});
        generateVIBQRCode(res.data?.user_name);
        window.dispatchEvent(new Event('user-data-updated'));
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const generateVIBQRCode = (username) => {
    if (!username) return;
    const qrData = `https://img.vietqr.io/image/VIB-086714172-compact2.jpg?amount=0&addInfo=user ${username} payment&accountName=NGUYEN THI HOA`;
    setBankInfo(prev => ({
      ...prev,
      qrCode: qrData
    }));
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    Swal.fire({
      icon: "success",
      title: "Đã sao chép vào bộ nhớ tạm!",
      showConfirmButton: false,
      timer: 1200
    });
  };

  const handleDownloadQR = () => {
    if (bankInfo.qrCode) {
      const link = document.createElement("a");
      link.href = bankInfo.qrCode;
      link.download = `QR_Code_${selectedBank}_${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        icon: "success",
        title: "Đã tải xuống mã QR!",
        showConfirmButton: false,
        timer: 1400
      });
    }
  };

  const handleDepositCode = () => {
    const cleanCode = (code || "").trim();
    if (!cleanCode) {
      Swal.fire({
        icon: "warning",
        title: "Vui lòng nhập mã Code!"
      });
      return;
    }

    setIsSubmittingCode(true);
    dispatch(setShowPreloader(true));

    CodeMoneyModel.depositCode({
      code: cleanCode,
    })
      .then((res) => {
        setIsSubmittingCode(false);
        dispatch(setShowPreloader(false));
        if (res.success === true) {
          Swal.fire({
            icon: "success",
            title: res.type === "vip" ? "Kích Hoạt VIP Thành Công!" : "Nạp Tiền Thành Công!",
            text: res.message,
            showConfirmButton: true,
            confirmButtonText: "Xác nhận"
          });
          setCode("");
          fetchUserData();
        } else {
          Swal.fire({
            icon: "error",
            title: "Không thể áp dụng mã",
            text: res.message || "Mã code không hợp lệ!"
          });
        }
      })
      .catch((err) => {
        setIsSubmittingCode(false);
        dispatch(setShowPreloader(false));
        Swal.fire({
          icon: "error",
          title: "Lỗi kết nối",
          text: err.response?.data?.message || err.message || "Không thể nạp mã code lúc này!"
        });
      });
  };

  const dispatch = useDispatch();
  const [perPage] = useState(5);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({});

  const changePage = (pageNum) => {
    setPage(pageNum);
    setFilter({ search: keyword });
  };
  const handleSetPage = (number) => {
    setPage(page + number);
    setFilter({ search: keyword });
  };

  const [keyword, setKeyword] = useState({
    start_date: "",
    end_date: "",
  });
  const [filter, setFilter] = useState({
    search: "",
    perPage: perPage,
    page: page,
  });

  const handleDateChange = (key, value) => {
    setKeyword({
      ...keyword,
      [key]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setPage(1);
    setFilter({ search: keyword });
  };

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };

  const [modalShowTransfer, setModalShowTransfer] = React.useState(false);
  const [modalShowTransferDemo, setModalShowTransferDemo] = React.useState(false);
  const [modalShowTransferACB, setModalShowTransferACB] = React.useState(false);
  const [infoOwner] = useState();
  const [ownerid] = useState();
  const [infoOwnerChanged, setInfoOwnerChanged] = useState();

  useEffect(() => {
    if (infoOwnerChanged) {
      setModalShowTransfer(true);
      setInfoOwnerChanged(false);
    }
  }, [infoOwner, infoOwnerChanged, ownerid]);

  const handleCloseModalTransfer = () => {
    setModalShowTransfer(false);
  };
  const handleCloseModalTransferDemo = () => {
    setModalShowTransferDemo(false);
  };
  const handleCloseModalTransferACB = () => {
    setModalShowTransferACB(false);
  };

  const [deposit, setDeposit] = useState([]);
  useEffect(() => {
    PaymentModel.getDeposit({
      search: filter.search,
      page: page,
      perPage: perPage,
    })
      .then((res) => {
        setDeposit(res.data || []);
        setMeta(res.meta || {});
      })
      .catch(() => {
        AppNotification.showError("Lấy lịch sử nạp tiền thất bại!");
      });
  }, [page, filter, perPage]);

  const [imageQR] = useState("");

  return (
    <MasterLayout>
      <div className="row g-3 mb-4">
        {/* Deposit via VietQR */}
        <div className="col-xl-6 col-lg-6">
          <div className="card bank-main-card h-100">
            <div className="bank-card-header">
              <h5 className="bank-header-title">
                <RiWallet3Line size={18} />
                <span>Nạp Tiền Tự Động Qua VietQR</span>
              </h5>
              <span className="status-pill ok">
                <span className="status-dot ok"></span>
                <span>Tự động 24/7</span>
              </span>
            </div>
            <div className="card-body p-4">
              <div className="wus-info-box p-4">
                {/* QR Code Section */}
                <div className="text-center mb-4">
                  <div style={{ color: "var(--wus-text)", fontWeight: 600, fontSize: "15.5px", marginBottom: "4px" }}>
                    Chuyển khoản nhanh qua mã QR
                  </div>
                  <div style={{ color: "var(--wus-text-muted)", fontSize: "12.5px", marginBottom: "16px" }}>
                    Mở ứng dụng ngân hàng bất kỳ và quét mã VietQR bên dưới
                  </div>
                  <div className="d-flex justify-content-center">
                    <div
                      style={{
                        width: "200px",
                        height: "200px",
                        padding: "10px",
                        borderRadius: "12px",
                        backgroundColor: "#ffffff",
                        border: "1px solid var(--wus-border-strong)",
                        boxShadow: "var(--wus-shadow-sm)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {bankInfo.qrCode ? (
                        <img
                          src={bankInfo.qrCode}
                          width={180}
                          height={180}
                          style={{
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                          alt="VietQR Code"
                          onClick={handleDownloadQR}
                          title="Bấm để tải ảnh QR"
                        />
                      ) : (
                        <div style={{ color: "#71717a", fontSize: "12.5px" }}>
                          Đang tạo mã QR...
                        </div>
                      )}
                    </div>
                  </div>
                  {bankInfo.qrCode && (
                    <button
                      type="button"
                      onClick={handleDownloadQR}
                      className="btn btn-secondary mt-3"
                      style={{ fontSize: "12px", padding: "5px 12px", display: "inline-flex", alignItems: "center", gap: "5px" }}
                    >
                      <RiDownload2Line size={14} />
                      <span>Tải mã QR về máy</span>
                    </button>
                  )}
                </div>

                {/* Divider */}
                <div style={{ borderTop: "1px solid var(--wus-border)", margin: "20px 0", paddingTop: "16px" }}>
                  <div className="text-center mb-3" style={{ color: "var(--wus-text-subtle)", fontWeight: 500, fontSize: "12.5px", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    Thông tin chuyển khoản thủ công
                  </div>
                </div>

                {/* Bank Information Details */}
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: "var(--wus-text-muted)", fontSize: "13px" }}>Ngân hàng thụ hưởng:</span>
                    <span style={{ color: "var(--wus-text)", fontWeight: 600, fontSize: "13.5px" }}>
                      {bankInfo.bankName}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: "var(--wus-text-muted)", fontSize: "13px" }}>Số tài khoản:</span>
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: "var(--wus-text)", fontWeight: 700, fontFamily: "var(--wus-mono)", fontSize: "14px" }}>
                        {bankInfo.accountNumber}
                      </span>
                      <button
                        type="button"
                        onClick={() => copyToClipboard(bankInfo.accountNumber)}
                        className="bento-card-link"
                      >
                        <RiFileCopyLine size={12} />
                        <span>Sao chép</span>
                      </button>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: "var(--wus-text-muted)", fontSize: "13px" }}>Chủ tài khoản:</span>
                    <span style={{ color: "var(--wus-text)", fontWeight: 600, fontSize: "13.5px" }}>
                      {bankInfo.accountName}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: "var(--wus-text-muted)", fontSize: "13px" }}>Nội dung chuyển khoản:</span>
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: "var(--wus-success-text)", fontWeight: 700, fontFamily: "var(--wus-mono)", fontSize: "13.5px" }}>
                        user {userData.user_name || "username"} payment
                      </span>
                      <button
                        type="button"
                        onClick={() => copyToClipboard(`user ${userData.user_name || "username"} payment`)}
                        className="bento-card-link"
                      >
                        <RiFileCopyLine size={12} />
                        <span>Sao chép</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Redeem Code Card */}
        <div className="col-xl-6 col-lg-6">
          <div className="card bank-main-card h-100 d-flex flex-column">
            <div className="bank-card-header">
              <h5 className="bank-header-title">
                <RiCoupon3Line size={18} />
                <span>Kích Hoạt Mã Code / Giftcode</span>
              </h5>
              <span className="bank-total-pill">Tức thì</span>
            </div>
            <div className="card-body p-4 d-flex flex-column justify-content-between">
              <div className="wus-info-box p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-center mb-4">
                    <div style={{ color: "var(--wus-text)", fontWeight: 600, fontSize: "15.5px", marginBottom: "4px" }}>
                      Đổi Mã Thưởng &amp; Lượt VIP
                    </div>
                    <div style={{ color: "var(--wus-text-muted)", fontSize: "12.5px" }}>
                      Nhập mã Giftcode để cộng tiền mặt hoặc cộng thêm ngày VIP tự động
                    </div>
                  </div>

                  <div className="mb-4">
                    <label style={{ color: "var(--wus-text-secondary)", fontSize: "12.5px", fontWeight: 600, marginBottom: "8px", display: "block" }}>
                      Mã kích hoạt của bạn:
                    </label>
                    <div className="d-flex gap-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Ví dụ: VIP8A9B2C, CODE250K..."
                        value={code}
                        onChange={(e) => setCode(e.target.value.toUpperCase().trim())}
                        style={{
                          background: "var(--wus-input-bg)",
                          border: "1px solid var(--wus-border-strong)",
                          color: "var(--wus-text)",
                          fontWeight: 700,
                          fontSize: "14px",
                          fontFamily: "var(--wus-mono)",
                          letterSpacing: "0.06em",
                          textTransform: "uppercase",
                          padding: "8px 14px",
                          borderRadius: "8px",
                          height: "38px"
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleDepositCode();
                          }
                        }}
                      />
                      <button
                        className="bank-action-btn btn-create-bank"
                        type="button"
                        onClick={handleDepositCode}
                        disabled={isSubmittingCode}
                        style={{ height: "38px", padding: "0 18px" }}
                      >
                        <RiShieldFlashLine size={15} />
                        <span>{isSubmittingCode ? "Đang xử lý..." : "Kích Hoạt"}</span>
                      </button>
                    </div>
                  </div>

                  {/* Information Callout Box */}
                  <div className="wus-summary-box mb-4">
                    <div className="d-flex align-items-start gap-2 mb-3">
                      <RiVipCrown2Fill size={16} style={{ color: "var(--wus-warning-text)" }} className="mt-1 flex-shrink-0" />
                      <span style={{ color: "var(--wus-text-secondary)", fontSize: "12.5px", lineHeight: "1.5" }}>
                        <strong style={{ color: "var(--wus-text)" }}>Mã VIP theo ngày:</strong> Tự động cộng số ngày VIP và quy đổi lượt tương ứng (<strong style={{ color: "var(--wus-warning-text)" }}>1 lượt = 30 ngày</strong>) dùng để tạo mới hoặc gia hạn Bank VIP.
                      </span>
                    </div>
                    <div className="d-flex align-items-start gap-2">
                      <RiWallet3Line size={16} style={{ color: "var(--wus-success-text)" }} className="mt-1 flex-shrink-0" />
                      <span style={{ color: "var(--wus-text-secondary)", fontSize: "12.5px", lineHeight: "1.5" }}>
                        <strong style={{ color: "var(--wus-text)" }}>Mã Tiền mặt:</strong> Tự động cộng số tiền mệnh giá trực tiếp vào số dư tài khoản của bạn ngay lập tức.
                      </span>
                    </div>
                  </div>
                </div>

                {/* User Current VIP & Balance Status */}
                <div className="wus-summary-box">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ color: "var(--wus-text-muted)", fontSize: "12.5px" }}>Số dư tài khoản hiện tại:</span>
                    <span style={{ color: "var(--wus-text)", fontWeight: 700, fontSize: "14px", fontFamily: "var(--wus-mono)" }}>
                      {(userData?.account_balance || 0).toLocaleString("vi-VN")} đ
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ color: "var(--wus-text-muted)", fontSize: "12.5px" }}>Quỹ ngày &amp; lượt VIP:</span>
                    <span style={{ color: "var(--wus-warning-text)", fontWeight: 600, fontSize: "13px" }}>
                      {userData?.combo_days || 0} ngày (~{Math.floor((userData?.combo_days || 0) / 30)} lượt)
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: "var(--wus-text-muted)", fontSize: "12.5px" }}>Chế độ bảo lưu VIP:</span>
                    <span style={{ color: "var(--wus-success-text)", fontSize: "12.5px", fontWeight: 600 }}>
                      {userData?.combo_days > 0 ? "Vĩnh viễn" : "Chưa kích hoạt"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Deposit History Section */}
      <div className="row">
        <div className="col-12">
          <div className="card bank-main-card">
            <div className="bank-card-header">
              <h5 className="bank-header-title">
                <RiHistoryLine size={18} />
                <span>Lịch Sử Nạp Tiền</span>
              </h5>
              <span className="bank-total-pill">
                {meta.total || deposit.length} giao dịch
              </span>
            </div>

            <div className="card-body p-0">
              {/* Date Filter Toolbar */}
              <div className="bank-toolbar">
                <div className="bank-perpage-wrap">
                  <span>Tra cứu lịch sử nạp tiền theo thời gian</span>
                </div>
                <form onSubmit={handleSubmit} className="d-flex align-items-center flex-wrap gap-2">
                  <div className="d-flex align-items-center gap-2">
                    <span style={{ color: "var(--wus-text-muted)", fontSize: "12.5px" }}>Từ ngày:</span>
                    <DatePicker
                      selected={keyword.start_date ? new Date(keyword.start_date) : null}
                      onChange={(date) => handleDateChange("start_date", date)}
                      maxDate={keyword.end_date ? new Date(keyword.end_date) : null}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="dd/mm/yyyy"
                      className="bank-search-input"
                      style={{ width: "135px" }}
                    />
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <span style={{ color: "var(--wus-text-muted)", fontSize: "12.5px" }}>Đến ngày:</span>
                    <DatePicker
                      selected={keyword.end_date ? new Date(keyword.end_date) : null}
                      onChange={(date) => handleDateChange("end_date", date)}
                      minDate={keyword.start_date ? new Date(keyword.start_date) : null}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="dd/mm/yyyy"
                      className="bank-search-input"
                      style={{ width: "135px" }}
                    />
                  </div>

                  <button className="bank-search-btn" type="submit">
                    <RiSearch2Line size={14} />
                    <span>Lọc dữ liệu</span>
                  </button>
                </form>
              </div>

              {/* Table */}
              <div className="bank-table-wrapper">
                <table className="bank-table">
                  <thead>
                    <tr>
                      <th>Số Tiền Nạp</th>
                      <th style={{ textAlign: "center", width: "140px" }}>Trạng Thái</th>
                      <th>Thời Gian Ghi Nhận</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deposit.length === 0 ? (
                      <tr>
                        <td colSpan="3" className="text-center py-5" style={{ color: "var(--wus-text-subtle)" }}>
                          Chưa có giao dịch nạp tiền nào trong khoảng thời gian này
                        </td>
                      </tr>
                    ) : (
                      deposit.map((item, key) => (
                        <tr key={key}>
                          <td>
                            <span className="table-balance-amount" style={{ color: "var(--wus-success-text)" }}>
                              +{item.received_fm} <span className="currency-unit">VNĐ</span>
                            </span>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.status == 1 ? (
                              <span className="status-pill ok">
                                <span className="status-dot ok"></span>
                                <span>Đã duyệt</span>
                              </span>
                            ) : (
                              <span className="status-pill" style={{ background: "var(--wus-warning-bg)", border: "1px solid var(--wus-warning-border)", color: "var(--wus-warning-text)" }}>
                                <span className="status-dot" style={{ background: "var(--wus-warning)" }}></span>
                                <span>Chờ duyệt</span>
                              </span>
                            )}
                          </td>
                          <td style={{ color: "var(--wus-text-muted)", fontSize: "12.5px", fontFamily: "var(--wus-mono)" }}>
                            {item.create_at_fm || "-"}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <div className="bank-pagination-wrap">
                <Paginate
                  meta={meta}
                  changePage={changePage}
                  page={page}
                  handleSetPage={handleSetPage}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Supporting Modals */}
        <ModalDeposit
          show={modalShowTransfer}
          onHide={handleCloseModalTransfer}
          bank={infoOwner}
          ownerid={ownerid}
        />
        <DemoModalDeposit
          show={modalShowTransferDemo}
          onHide={handleCloseModalTransferDemo}
        />
        <ModalACB
          show={modalShowTransferACB}
          onHide={handleCloseModalTransferACB}
          imageQR={imageQR}
        />

        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Nạp tiền vào tài khoản</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-2" style={{ color: "var(--wus-text-secondary)", fontSize: "13px" }}>
              Số tiền muốn nạp:
            </div>
            <Form.Control type="text" placeholder="500.000" autoFocus />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Đóng
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Xác nhận
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </MasterLayout>
  );
}

export default PaymentDepositPage;
